import { render, staticRenderFns } from "./NewsFour.vue?vue&type=template&id=49ffd026&scoped=true"
import script from "./NewsFour.vue?vue&type=script&lang=js"
export * from "./NewsFour.vue?vue&type=script&lang=js"
import style0 from "./NewsFour.vue?vue&type=style&index=0&id=49ffd026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffd026",
  null
  
)

export default component.exports